import StateSavingComponent from "src/components/base/StateSavingComponent";
import Hasher from "src/utils/Hasher";
import StateHandler from "src/states/StateHandler";
import StateConstants from "src/states/StateContstants";

class ValuationStateHelper {

    static getComparableHomesInputField(component: StateSavingComponent) {
        return {
            "address": component.getState("street-address"),
            "country": component.getState("country"),
            "county": component.getState("county"),
            "town": component.getState("town")
        }
    }

    static getValuationInputField(component: StateSavingComponent) {
        let comparableHomes: any[] = []
        comparableHomes = ValuationStateHelper.getComparableHomesForValuation(component);
        let currentHouseCondition = component.getState("current-house-condition")
        return {
            "comparison_valuations": comparableHomes,
            "asset": {
                "current_state": parseFloat(currentHouseCondition) / 100,
                "future_state": parseFloat(currentHouseCondition) / 100
            }
        }
    }

    static getComparableHomesForValuation(component: StateSavingComponent) {
        let comparableHomesWidget = component.getState("comparableHomes")
        let comparableHomes = []
        for (let comparableHomeWidget of Object.values(comparableHomesWidget)) {
            let comparableHome = ValuationStateHelper.convertDictToComparableHome(comparableHomeWidget)
            comparableHomes.push(comparableHome)     
        }
        return comparableHomes
    }

    static getComparableHomes(component: any) {
        let comparableHomes = component.getState("comparableHomes");
        return Object.values(comparableHomes)
    }

    static setComparableHomes(component: any, comparableHomes: any) {
        component.assignState("comparableHomes", {})
        let comparableHomesCopy = JSON.parse(JSON.stringify(comparableHomes));
        for (let comparableHome of comparableHomesCopy) {
            ValuationStateHelper.updateComparableHome(component, Hasher.hash(comparableHome), comparableHome)
        }
    }

    static updateComparableHome(component: any, id: string, comparableHome: any) {
        let updatedComparableHomes = component.getState("comparableHomes")
        updatedComparableHomes[id] = comparableHome
        component.assignState("comparableHomes", updatedComparableHomes)
    }

    static updateComparableHomeField(component: any, id: string, key: string, value: any) {
        let updatedComparableHomes = component.getState("comparableHomes")
        updatedComparableHomes[id][key] = value
        component.assignState("comparableHomes", updatedComparableHomes)
    }

    static isComparableHomeRemoved(component: StateHandler, id: string) {
        let removedHomes = component.get(StateConstants.REMOVED_HOMES)
        if (id.length <= 5) {
            return false
        }
        for (let removedHome of removedHomes) {
            if (removedHome == id || removedHome.endsWith(id)) {
                return true
            }
        }
        return false
    }

    static removeComparableHomes(component: StateHandler, ids: string[]) {
        for (let id of ids) {
            ValuationStateHelper.removeComparableHome(component, id)
        }
    }

    static removeComparableHome(component: StateHandler, id: string) {
        if (id.length <= 5) {
            return
        }
        let comparableHomes = component.get(StateConstants.COMPARABLE_HOMES_STATE)
        let comparableAddresses = comparableHomes["comparable_addresses"]
        for (let comparableAddress of comparableAddresses) {
            if (comparableAddress["id"] == id || comparableAddress["id"].endsWith(id)) {
                comparableAddress["sv"] = false
                break
            }
        }
        component.set(StateConstants.COMPARABLE_HOMES_STATE, comparableHomes)
    }

    static removeSavedValuation(component: StateHandler, id: string) {
        let savedValuations = component.get(StateConstants.SAVED_VALUATIONS)
        savedValuations["i"] = savedValuations["i"].filter((valuation: any) => valuation.id !== id)
        component.set(StateConstants.SAVED_VALUATIONS, savedValuations)
    }

    static addSavedValuation(component: StateHandler, savedValuation: any) {
        let savedValuations = component.get(StateConstants.SAVED_VALUATIONS)
        savedValuations["i"] = savedValuations["i"].filter((valuation: any) => valuation.id !== savedValuation.id)
        savedValuations["i"].push(savedValuation)
        component.set(StateConstants.SAVED_VALUATIONS, savedValuations)
    }

    static convertDictToComparableHome(dict: any) {
            let comparableHome: any = {
                "value": dict["value"]
            }
            if ("state" in dict) {
                comparableHome["state"] = dict["state"]
            }
            return comparableHome
    }
}

export default ValuationStateHelper
